<div class="meeting-recording-page">
  <h1>商談録音</h1>

  <form [formGroup]="form" class="recording-form">
    <div class="detail">
      <label class="label" for="title">商談名：</label>
      <div class="value">
        <input
          id="title"
          class="input-control"
          formControlName="title"
          type="text"
          placeholder="商談名を入力"
        />
      </div>
    </div>

    <div class="detail">
      <label class="label" for="account-name">顧客名（任意）：</label>
      <div class="value">
        <input
          id="account-name"
          class="input-control"
          placeholder="顧客名を入力"
          [formControl]="accountName"
          [matAutocomplete]="accountNameAuto"
        />
        <mat-autocomplete #accountNameAuto="matAutocomplete">
          @for (account of filteredAccounts | async; track account) {
            <mat-option [value]="account.name">
              {{ account.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </div>
    </div>

    @if (!isEvaluationSkipped) {
      <div class="detail">
        <span class="label">スキルマップ：</span>
        <div class="value">
          <app-select
            [id]="'skill-map'"
            [options]="skillMapOptions"
            [selectedOption]="selectedSkillMap"
            (selectedOptionChange)="changeSkillMap($event)"
          ></app-select>
          @if (skillMapError) {
            <div class="field-error">
              {{ skillMapError }}
            </div>
          }
        </div>
      </div>
    }
  </form>

  <div class="recording-controls">
    @if (micError) {
      <div class="error-message">{{ micError }}</div>
    }
    @if (backgroundWarning) {
      <div class="warning-message">
        {{ backgroundWarning }}
      </div>
    }

    @if (isRecording) {
      <div class="recording-status">
        <app-audio-waveform [mediaStream]="mediaStream"></app-audio-waveform>
        <div class="elapsed-time">{{ formattedElapsedTime }}</div>
        @if (uploadProgress$ | async; as progress) {
          <div class="upload-progress">
            アップロード: {{ progress.uploaded }} /
            {{ progress.total }} チャンク
          </div>
        }
      </div>
    }

    <div class="buttons">
      @if (!isRecording) {
        <button
          class="start-button"
          [disabled]="!canStartRecording"
          (click)="onStartRecording()"
        >
          録音開始
        </button>
      }

      @if (isRecording) {
        <button class="stop-button" (click)="onStopRecording()">
          ■ 録音終了
        </button>
      }
    </div>

    <p class="note">※ 録音は90秒以上行ってください</p>
    <p class="note">※ 録音終了後、アセスメントの評価が自動で開始されます</p>
  </div>
</div>
